import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/notification/mutationTypes';

export default {
  [types.SET_NOTIFICATIONS]: createSetPropMutation('notifications', []),
  [types.CLEAR_NOTIFICATIONS]: createClearPropMutation('notifications', []),
  [types.SET_UNREAD_NOTIFICATIONS]: createSetPropMutation('unreadNotifications', []),
  [types.CLEAR_UNREAD_NOTIFICATIONS]: createSetPropMutation('unreadNotifications', []),
  [types.SET_NOTIFICATION_LIST_OPTIONS](state, options = {}) {
    state.notificationListOptions = {
      ...(state.notificationListOptions || {}),
      ...options,
    };
  },
};
